<div class="account-pages py-4 auth-layout bg-color">
    <div class="container centered-div ">
        <div class="row justify-content-center gutter-x-0">
            <div class="col-md-8 col-lg-6 col-xl-5">
                <div class="">
                    <div class="row gutter-x-0">
                        <div class="col-12 text-center">
                            <a routerLink="/">
                                <img src="assets/images/identity/logo-white.svg" alt="" class="img-fluid logo-auth">
                            </a>
                        </div>
                    </div>
                </div>
                
                <div class="card overflow-hidden">
                    <div class="card-body pt-4">
                        <router-outlet />
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>